












































































































































































import Vue, { PropType } from 'vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import FieldCheckbox from '@/components/form/FieldCheckbox.vue';
import SelectChipsFromRightSlide from '@/components/chips/SelectChipsFromRightSlide.vue';
import FieldSelect from '@/components/form/FieldSelect.vue';
import { InventoryData } from '@/types/campaign/settings';
import ChipsTree, { IChipTreeData } from '@/utils/ChipsTree';
import { IChipsData } from '@/types';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'TheInventory',
  components: {
    WidgetWrapper,
    FieldCheckbox,
    SelectChipsFromRightSlide,
    FieldSelect,
  },

  props: {
    data: {
      type: Object as PropType<InventoryData>,
      required: true,
    },
  },

  mounted() {
    this.sspList = this.formatedSspList;
  },

  watch: {
    data() {
      this.campaign = this.data;
    },
    formatedSspList(list) {
      this.sspList = list;
    },
    filterTypeTraffic() {
      this.filterSsp();
    },
    filterSspGeo() {
      this.filterSsp();
    },
  },

  computed: {
    ...mapGetters({
      getSsp: 'getSsp',
      countries: 'countriesList',
      trafficTypes: 'dictionary/getTrafficTypes',
      category: 'categoryList',
    }),
    campaignSsp(): Array<IChipTreeData> {
      return (
        ChipsTree.formatToChipTreeData(this.campaign.ssp_targets, 'value') || []
      );
    },
    formatedSspList(): Array<any> {
      return this.getSsp.map((ssp) => {
        let creativeFormat = '';
        let trafficTypes = '';
        let geo = '';

        if (ssp.creative_formats?.length) {
          creativeFormat = ssp.creative_formats
            .map((cf) => `${cf.width}x${cf.height}`)
            .join(', ');
        }

        if (ssp.traffic_types?.label) {
          trafficTypes = ssp.traffic_types.value.toString();
        }

        if (ssp.geo?.length) {
          geo = ssp.geo.join(', ');
        }

        return {
          id: ssp.id,
          name: ssp.name,
          value: ssp.id.toString(),
          parent_id: ssp.id,
          data: {
            id: ssp.id,
            img: ssp.img,
            comment: ssp.comment,
            rules: ssp.rules,
            trafficTypes,
            geo,
            creativeFormat,
          },
        };
      });
    },
  },

  methods: {
    changeCampaign(name, value) {
      this.$emit('changeCampaign', name, value);
    },
    changeSspList(sspList) {
      this.campaign.ssp_targets = sspList.map((ssp) => ssp);
      this.changeCampaign('ssp_targets', this.campaign.ssp_targets);
    },
    filterSsp() {
      this.sspList = this.formatedSspList;

      if (this.filterTypeTraffic) {
        const type = this.trafficTypes.find(
          (t) => t.value === this.filterTypeTraffic
        );
        this.sspList = this.sspList.filter(
          (ssp: IChipsData) => ssp.data.trafficTypes === type?.value
        );
      }

      if (this.filterSspGeo) {
        const country = this.countries.find(
          (c) => c.value === this.filterSspGeo
        );

        if (country) {
          this.sspList = this.sspList.filter((ssp: IChipsData) =>
            ssp.data.geo.includes(country?.value)
          );
        }
      }
    },
    clearSspFilters() {
      this.filterTypeTraffic = '';
      this.filterSspGeo = '';
    },
    changeChecked(checked) {
      this.changeCampaign('is_inventory', checked);
    },
  },

  data() {
    return {
      campaign: this.data,
      sspList: [] as Array<IChipsData>,
      filterTypeTraffic: '',
      filterSspGeo: '',
    };
  },
});
